export class MapStats {
    constructor(
        public mapName: string,
        public amountPicked: number,
        public amountBanned: number,
        public amountPlayed: number,
        public amountWon: number,
        public chosenCTPercentage: number,
    ) { }
}